import type { FaireProductEntity } from "../../entity_types/product";

export const p_nkvnq4skw2: FaireProductEntity = {
  token: "p_nkvnq4skw2",
  type: "product",
  name: "Woon Wok Legend's Seasoning Salt",
  brandToken: "b_th428x9zzy",
  brandName: "Woon",
  imageUrl: "https://cdn.faire.com/fastly/da66f5652eeeb1f13a45a8fe66c6217e9ae5d1063e7ab62725c81f30dacb29b5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a3869df3fcdeb60f9b75e510f32f925ddfe3e0e92c50061bc7735e52c568de0c.jpeg",
    "https://cdn.faire.com/fastly/ad698043915e8eb8edb60a3871ead6fb954ba97fcb48fc7df609a5514a330ffa.jpeg",
    "https://cdn.faire.com/fastly/73e4bd6a7da0a02a4146cb8dcd91af0257dec9214f4fdf9b901d9ddcfd1cd217.jpeg",
    "https://cdn.faire.com/fastly/4d98b50a1ae5f782acb252c7f80ad6768e3ecada17bdd2251d8b31d3a29994ce.jpeg"
  ],
  priceDollars: 5.6,
  description: "Brian ‘Wok Legend’ is our Master Wok Chef at Woon. He's known for his secret seasoning he adds to every dish and we’ve bottled it up for you. Wok Legend’s Seasoning Salt is great on rice, avocado toast, eggs, popcorn, potato chips, soups, noodles, soba… possibly anything.",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:06.352Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
